import Vue from 'vue'
import axios from 'axios'
import lscache from 'lscache'
import md5 from 'md5'

class AppApi {
  // instance;
  constructor() {
    this.instance = axios.create()
    lscache.flush()
  }

  call(action, method, data, fromCache) {
    fromCache = fromCache === true ? true : false

    let url =
      process.env.VUE_APP_API_URL + (action[0] === '/' ? '' : '/') + action
    let keyCache = null

    let request = {
      method: method,
      url: url,
      headers: {
        Authorization: 'Bearer ' + Vue.auth.token()
      }
    }

    if (method === 'GET') {
      request.params = data
      keyCache = md5(url + JSON.stringify(data))
    } else {
      request.data = data
    }

    return new Promise((resolve, reject) => {
      if (fromCache === true && keyCache && lscache.get(keyCache)) {
        resolve(lscache.get(keyCache))
      } else {
        this.instance
          .request(request)
          .then(result => {
            if (fromCache === true && keyCache) {
              lscache.set(keyCache, result, 5)
            }
            resolve(result)
          })
          .catch(error => {
            reject(error)
          })
      }
    })
  }

  //home
  getHome(data) {
    return this.call('/portal/home', 'GET', data)
  }

  //user
  postAuthRegister(data) {
    return this.call('/auth/register', 'POST', data)
  }

  getUsers(data) {
    return this.call('/portal/users', 'GET', data)
  }

  getAuthUser() {
    return this.call('/auth/user', 'GET')
  }

  validateUser(data) {
    return this.call('/auth/validate', 'POST', data)
  }

  getUsersByCpf(data) {
    return this.call('/portal/users/bycpf', 'GET', data)
  }

  postUserPushNotification(data) {
    return this.call('portal/user-push-notification', 'POST', data)
  }

  putUserUser(id, data) {
    return this.call('/portal/users/' + id, 'PUT', data)
  }

  putUsersPicture(data) {
    return this.call('/portal/users/picture', 'PUT', data)
  }

  putUserAddress(data) {
    return this.call('/portal/users/address', 'PUT', data)
  }

  // Users available to transfer property

  getExplorerUsers(data) {
    return this.call('/portal/explorer-users', 'GET', data)
  }

  postExplorerUsers(data) {
    return this.call('/portal/explorer-users', 'POST', data)
  }

  //romaneios
  getRomaneios(data) {
    return this.call('/portal/romaneios', 'GET', data, true)
  }
  getRomaneioPdf(id) {
    return this.call('/portal/romaneios/pdf/' + id, 'GET', {}, true)
  }
  getRomaneio(id) {
    return this.call('/portal/romaneios/' + id, 'GET', {}, true)
  }
  getRomaneioImages(id, nr_sequencial) {
    return this.call(
      '/portal/romaneios/images/' + id + '/' + nr_sequencial,
      'GET',
      {},
      true
    )
  }
  getRomaneioAuxs() {
    return this.call('/portal/romaneios/auxs', 'GET', {}, true)
  }
  getRomaneiosAccess(data) {
    return this.call('/portal/romaneios/access', 'GET', data)
  }
  postRomaneiosAccess(data) {
    return this.call('/portal/romaneios/access', 'POST', data)
  }
  deleteRomaneiosAccess(id) {
    return this.call('/portal/romaneios/access/' + id, 'DELETE')
  }
  postRomaneiosNegotiation(data) {
    return this.call('/portal/romaneios/negotiation', 'POST', data)
  }
  postRomaneiosAccessRequest(data) {
    return this.call('/portal/romaneios/access-request', 'POST', data)
  }
  putRomaneiosAccessRequest(id) {
    return this.call('/portal/romaneios/access-request/' + id, 'PUT', {})
  }

  //access token
  getRomaneioAccessTokens(data) {
    return this.call('/portal/romaneio-access-token', 'GET', data)
  }
  postRomaneioAccessToken(data) {
    return this.call('/portal/romaneio-access-token', 'POST', data)
  }
  putRomaneioAccessToken(id, data) {
    return this.call('/portal/romaneio-access-token/' + id, 'PUT', data)
  }
  deleteRomaneioAccessToken(id) {
    return this.call('/portal/romaneio-access-token/' + id, 'DELETE')
  }

  //propriedades
  getProperties(data) {
    return this.call('/portal/properties', 'GET', data)
  }
  getProperty(id) {
    return this.call('/portal/properties/' + id, 'GET', {})
  }
  postProperty(data) {
    return this.call('/portal/properties', 'POST', data)
  }
  putProperty(id, data) {
    return this.call('/portal/properties/' + id, 'PUT', data)
  }
  deleteProperty(id) {
    return this.call('/portal/properties/' + id, 'DELETE')
  }

  transferProperty(id, data) {
    return this.call(`/portal/property/${id}/transfer`, 'POST', data)
  }

  //contacts
  postPropertyContact(data) {
    return this.call('/portal/properties/contacts', 'POST', data)
  }
  putPropertyContact(id, data) {
    return this.call('/portal/properties/contacts/' + id, 'PUT', data)
  }

  //explorer
  getExplorers(data) {
    return this.call('/portal/explorers', 'GET', data)
  }
  getExplorersAll(data) {
    return this.call('/portal/explorers/all', 'GET', data)
  }
  postExplorer(data) {
    return this.call('/portal/explorers', 'POST', data)
  }
  putExplorer(id, data) {
    return this.call('/portal/explorers/' + id, 'PUT', data)
  }
  deleteExplorer(id) {
    return this.call('/portal/explorers/' + id, 'DELETE')
  }
  deleteExplorerByProperty(data) {
    return this.call('/portal/explorers', 'DELETE', data)
  }

  //address
  getAddressStates() {
    return this.call('/portal/address/states', 'GET', {})
  }
  getAddressCities(data) {
    return this.call('/portal/address/cities', 'GET', data)
  }
  getAddressCity(id) {
    return this.call('/portal/address/cities/' + id, 'GET', {})
  }

  //feedback
  getFeedback(data) {
    return this.call('/portal/feedbacks', 'GET', data)
  }
  postFeedback(data) {
    return this.call('/portal/feedbacks', 'POST', data)
  }

  //reset password
  postResetPassword(data) {
    return this.call('/portal/reset-password', 'POST', data)
  }
  getResetPassword(token) {
    return this.call('/portal/reset-password/' + token, 'GET')
  }
  putResetPassword(token, data) {
    return this.call('/portal/reset-password/' + token, 'PUT', data)
  }

  //track
  getTrack(data) {
    return this.call('/track', 'GET', data)
  }

  //alerts
  getUserAlerts(data) {
    return this.call('/portal/user-alerts', 'GET', data)
  }
  putUserAlerts() {
    return this.call('/portal/user-alerts/all', 'PUT', true)
  }

  getAlertPreferencesEmail(data) {
    return this.call('/portal/alert-preferences/email', 'GET', data)
  }

  postAlertPreferencesEmail(data) {
    return this.call('/portal/alert-preferences/email', 'POST', data)
  }

  getRomaneioAlert(data) {
    return this.call('/portal/romaneio-alert', 'GET', data)
  }

  getCamerasBySif(sif) {
    return this.call(`/portal/industries/sif/${sif}/cameras`, 'GET')
  }

  getAbateAoVivo() {
    return this.call('/portal/abateonline', 'GET')
  }

  getSlaughterSchedule() {
    return this.call('/portal/slaughter-schedule', 'GET')
  }

  getSlaughterScheduleInfo(data) {
    return this.call('/portal/slaughter-schedule-info', 'GET', data)
  }

  getSlaughterStreamUrl(id) {
    return this.call(`/portal/abateonline/${id}`, 'GET')
  }
}

const appApi = new AppApi()

export default appApi
